import { Fragment, useState } from "react";
import Config from "../../../Config";
import InputComboRok from "../../../helpers/InputComboRok";
import InputComboMiesiac from "../../../helpers/InputComboMiesiac";
import InputLegend from "../../../helpers/InputLegend";
import InputTextAlpha from "../../../helpers/InputTextAlpha";
import InputPhone from "../../../helpers/InputPhone";
import InputPESEL from "../../../helpers/InputPESEL";
import InputText from "../../../helpers/InputText";
import FormatDecimal from "../../../helpers/FormatDecimal";
import MediaBrowser from "../../../helpers/MediaBrowser";

import ico_pdf from "../../../ico_pdf.png";


 
function Invoice(props)
{


    
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);





 

    const getData = () => {


        props.mainView.setProgress(-2);
 

        fetch( Config.url + '/rest_v1_parents,invoices', {
            method: 'POST', 
            body: JSON.stringify( {} ), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                                                                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
               



    }



 

  

    
    if(tab == null)
        {
            setTab([]);
            getData();      
            return (
                <div></div>
            );        
        }


    
    if(refreshView != props.userData.refreshView)
    {         
          setRefreshView( props.userData.refreshView);
          setTab(null);
    }    



 

    return <div>
             

                        <div className="bg_center gocentermobile">
                          
 

                           <div className="calColor" >Saldo płatności na poszczególnych kontach (kwota dodatnia oznacza nadpłatę):   </div>
                            <ul className="parents_eat">

                                   {
                                      tab.salda != undefined &&
                                      <Fragment>

                                            {
                                                tab.salda.map( (item, ix) => {

                                                    return <li>
                                                            <div className="gobold"><FormatDecimal value={item.saldo} /> zł</div>
                                                            <div>{item.nazwa}, &nbsp;  {item.imie} {item.nazwisko}</div>
                                                    </li>

                                                } )
                                            }

                                      </Fragment>
                                   } 

                            </ul>

                            {
                                tab.f != undefined &&
                                <Fragment>
                                        <div className="calColor" >Ostatnio wystawione rachunki / faktury {tab.f.length}:   </div>

                                        <br/>

                                        <div className="scorll_x">
                                            
                                                <table className="table"  >
                                                            <thead>
                                                                        <tr className="header">
                                                                            <td className="td_left gocenter">LP</td>
                                                                            <td className="gocenter">Numer</td>                                                                                      
                                                                            <td>Data wystawienia</td>                                                                                                                                       
                                                                            <td>Termin płatności</td>                                                                                                                                       
                                                                            <td>Do zapłaty</td>                                                                                                                                       
                                                                            <td>Kwota rozliczenia</td>                                                                                                                                       
                                                                            <td>Kwota odsetek</td>                                                                                                                                       
                                                                            <td>Kwota rozliczenia odsetek</td>                                                                                                                                                                                                      
                                                                            <td className="td_right">Pozostało</td>
                                                                            <td className="td_option"> </td>                                                   
                                                                            <td className="td_option"> </td>                                                   
                                                                        </tr>
                                                            </thead>

                                                            <tbody>
                                                                    {
                                                                        tab.f.map( (item, ix) => {                                                                            
                                                                        return <tr className="eee">
                                                                                <td className="gocenter">{ix+1}</td>
                                                                                <td className="gocenter">{item.numer}</td>                                                                                      
                                                                                <td className="gocenter">{item.data_wystawienia}</td>                                                                                                                                       
                                                                                <td className="gocenter">{item.termin_platnosci}</td>                                                                                                                                       
                                                                                <td className="goright"><FormatDecimal value={item.do_zaplaty}/></td>                                                                                                                                       
                                                                                <td className="goright"><FormatDecimal value={item.kwota_rozliczenia}/></td>                                                                                                                                       
                                                                                <td className="goright"><FormatDecimal value={item.kwota_odsetek}/></td>                                                                                                                                       
                                                                                <td className="goright"><FormatDecimal value={item.kwota_rozliczenia_odsetek}/></td>                                                                                                                                                                                                      
                                                                                <td className="goright"><FormatDecimal value={item.pozostalo}/></td>

                                                                                <td className="td_option"> 
                                                                                    {
                                                                                        item.api_unique != undefined && item.api_unique.length > 5 &&
                                                                                        <Fragment>
                                                                                            <MediaBrowser userData={props.userData} mainView={props.mainView}  review={ ico_pdf }  crypt={item.api_unique} typ="" typId={-1} />
                                                                                        </Fragment>
                                                                                    }                                                                          
                                                                                </td>

                                                                                <td className="td_option"> 

                                                                                {
                                                                                    item.link != undefined && item.link.length > 5 &&
                                                                                    <Fragment>
                                                                                        <a href={item.link} target="_blank" className="link_color" >&nbsp;&nbsp;zapłać&nbsp;&nbsp;</a>
                                                                                    </Fragment>
                                                                                }    
                                                                                    
                                                                                </td>                                                   
                                                                        </tr>

                                                                        } )
                                                                    }
                                                            </tbody>
                                                </table>

                                        </div>

                                      
                                </Fragment>
                            }
                           

                        


                        </div>
 
    </div>
}


export default Invoice;